import { EventLocation } from "./calendar"
import { MetaData } from "./meta"
import { z } from "zod"

interface IntakeLocation extends EventLocation {
  distance: number
}

interface IntakeLocationsResponse {
  data: {
    locations: IntakeLocation[]
  }
  meta: MetaData
}

interface IntakeDate {
  id: number
  date: string
  startTime: string
  endTime: string
}

interface IntakeDatesResponse {
  data: {
    intakes: IntakeDate[]
  }
}

export const literateEnum = z.enum(["yes", "no", "doubt"], {
  message: "Dit veld is verplicht",
})

type LiterateEnum = z.infer<typeof literateEnum>

export type {
  IntakeLocation,
  IntakeLocationsResponse,
  IntakeDate,
  IntakeDatesResponse,
  LiterateEnum,
}
